import { render } from "./Mercenary.vue?vue&type=template&id=29ba8f6f"
import script from "./Mercenary.vue?vue&type=script&lang=js"
export * from "./Mercenary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__